var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWritingassistant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.012,
    height: 27.012,
    viewBox: "0 0 27.012 27.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.012,13.432a1.312,1.312,0,0,0-.383-.925l-1.85-1.845a1.339,1.339,0,0,0-1.85,0l-2.893,2.893V2H7.918L2,7.918V29.012H22.041V20.956H22.03l6.6-6.6A1.3,1.3,0,0,0,29.012,13.432ZM13.783,23.54l1.967,1.967-2.558.59Zm2.829,1.6-2.467-2.467,8.316-8.316,2.462,2.462Zm6.471-11.4,1.234-1.234,2.462,2.467-1.234,1.234ZM7.663,3.489V7.663H3.489ZM21.169,28.14H2.872V8.535H8.535V2.872H21.169V14.411h.016l-3.711,3.711H4.18v.872H16.6l-3.052,3.052H4.18v.872h8.853l-.7,3.052H4.18v.861h8.242l.016.016a.652.652,0,0,0,.463.191.709.709,0,0,0,.149-.016l3.424-.792h0a1.253,1.253,0,0,0,.627-.351l4.073-4.073V28.14Zm6.843-14.4-.617.617L24.933,11.9l.617-.617a.439.439,0,0,1,.308-.128.448.448,0,0,1,.308.128l1.85,1.85a.439.439,0,0,1,.128.308A.411.411,0,0,1,28.012,13.741Z",
    transform: "translate(-2 -2)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.25,
    height: 0.872,
    transform: "translate(2.18 12.198)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.1,51.2H215v7.843h6.1Zm-.867,6.971h-4.355v-6.1h4.355Z",
    transform: "translate(-203.674 -48.584)",
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritingassistant);
export default __webpack_public_path__ + "static/media/writingassistant.edd82c77.svg";
export { ForwardRef as ReactComponent };